const DNSSMPI_CATEGORY = 'C0004';

const SOPORTO_HOSTS_LIVE = ['soporto.king.com', 'soporto-live.ext.p.midasplayer.cloud'];

const ONE_TRUST_ID_QA = '70a7b71d-9be2-4563-aa6b-87e8bb4b15ec-test';
const ONE_TRUST_ID_LIVE = '70a7b71d-9be2-4563-aa6b-87e8bb4b15ec';

export const updateOneTrustPreferences = (response) => {
    const oneTrustId = SOPORTO_HOSTS_LIVE.includes(window.location.host) ? ONE_TRUST_ID_LIVE : ONE_TRUST_ID_QA;
    window.OneTrust = {
        dataSubjectParams: {
            id: String(response.cuid),
            isAnonymous: false,
            token: response.jwt
        },
        geolocationResponse: {
            stateCode: 'CA',
            countryCode: 'US'
        }
    };

    let consentUpdated = false;
    window.OptanonWrapper = () => {
        if (window.OneTrust.IsAlertBoxClosed() === false) {
            var banner = document.getElementById('onetrust-banner-sdk');
            banner.style.display = 'none';
        }
        if (!consentUpdated) {
            window.OneTrust.UpdateConsent('Category', `${DNSSMPI_CATEGORY}:0`);
            consentUpdated = true;
        }
    };

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.setAttribute('data-document-language', true);
    script.setAttribute('data-domain-script', oneTrustId);
    script.async = true;
    script.src = `https://cdn-ukwest.onetrust.com/consent/${oneTrustId}/otSDKStub.js`;

    const el = document.getElementsByTagName('script')[0];
    el.parentNode.insertBefore(script, el);
};



// WEBPACK FOOTER //
// ./src/utils/updateOneTrustPreferences.js